import { Box, Container, Grid, Typography, Button } from '@mui/material';
import heroMain from '../../assets/hero-main.png'

const Hero = () => {
  const handleOrderNow = () => {
    window.scrollBy({
      top: window.innerHeight * 0.8,
      left: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${heroMain})`,
        backgroundSize: 'cover',
        backgroundPosition: 'left center',
        height: '550px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="xl">
        <Grid container>
          {/* Left Grid (empty for spacing) */}
          <Grid size={{xs:12, md:5, lg:5}}></Grid>

          {/* Right Grid (content) */}
          <Grid size={{xs:12, md:7, lg:7}} >
            <Box sx={{ color: '#fff', textAlign: 'left', maxWidth: 700 }}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '40px', md: '40px', lg:'60px' },
                  fontWeight: 600,
                  fontFamily: 'Poppins',
                  lineHeight: 1.2,
                  color: '#fff',
                  mb: 2,
                }}
              >
                Indian Book House <br />
                Best Choices for <br />
                Competitive exams
              </Typography>

              {/* Discount Banner */}
              <Box
                sx={{
                  backgroundColor: '#2e2e2e',
                  color: 'secondary.cart',
                  display: 'inline-block',
                  px: 3,
                  py: 1.5,
                   fontSize: { xs: '14px', md: '20px', lg:'20px' },
                  fontWeight: 400,
                  mb: 2,
                  fontFamily: 'Poppins',
                }}
              >
                Get flat 25% Discount on your First order
              </Box>

              {/* Order Button */}
              <Box>
                <Button disableRipple disableFocusRipple
                  disableElevation
                  disableTouchRipple
                  variant="contained"
                  onClick={handleOrderNow}
                  sx={{
                    mt: 1, backgroundColor: 'secondary.main', color: '#000', textTransform: 'none', fontFamily: 'Poppins',  fontWeight: 600,
                    fontSize: { xs: '14px', md: '16px', lg:'20px' },
                    px: 4,  py:1.5,  borderRadius:'0px',
                    
                  }}
                >
                  Order Now
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
